import axios from '@/axiosInterceptor';

const state = () => ({
  rates: [],
  rates_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  viewed_rates: [],
  viewed_rates_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  delivered_rates: [],
  delivered_rates_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  delivered_rates_is_loaded: false,
  accepted_rates: [],
  accepted_rates_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  cancelled_rates: [],
  cancelled_rates_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  rejected_rates: [],
  rejected_rates_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  current_rate: null,
  current_rate_terms: null,
});

// getters
const getters = {};

// actions
const actions = {
  async getAllRates(
    { commit },
    { currentPage = 1, user_id = '', searchText = '' }
  ) {
    let query = '';
    if (user_id) {
      query = `&q[creator_id_eq]=${user_id}`;
    }

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations?q[s]=id+desc&page=${currentPage}&per_page=50${query}${searchText}`
      );
      commit('setRates', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getViewedRates(
    { commit },
    { currentPage = 1, user_id = '', searchText = '' }
  ) {
    let query = '';
    if (user_id) {
      query = `&q[creator_id_eq]=${user_id}`;
    }
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations?q[s]=id+desc&q[status_eq]=viewed&page=${currentPage}&per_page=50${query}${searchText}`
      );
      commit('setViewedRates', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getDeliveredRates(
    { commit },
    { currentPage = 1, user_id = '', searchText = '' }
  ) {
    let query = '';
    if (user_id) {
      query = `&q[creator_id_eq]=${user_id}`;
    }

    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations?q[s]=id+desc&q[status_eq]=delivered&page=${currentPage}&per_page=50${query}${searchText}`
      );
      commit('setDeliveredRates', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    } finally {
      commit('setDeliveredRatesIsLoaded', true);
    }
  },
  async getAcceptedRates(
    { commit },
    { currentPage = 1, user_id = '', searchText = '' }
  ) {
    let query = '';
    if (user_id) {
      query = `&q[creator_id_eq]=${user_id}`;
    }
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations?q[s]=id+desc&q[status_eq]=accepted&page=${currentPage}&per_page=50${query}${searchText}`
      );
      commit('setAcceptedRates', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getCancelledRates(
    { commit },
    { currentPage = 1, user_id = '', searchText = '' }
  ) {
    let query = '';
    if (user_id) {
      query = `&q[creator_id_eq]=${user_id}`;
    }
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations?q[s]=id+desc&q[status_eq]=cancelled&page=${currentPage}&per_page=50${query}${searchText}`
      );
      commit('setCancelledRates', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getRateDetail({ commit }, id) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations/${id}`
      );
      commit('setCurrentRate', res?.data);
      return res?.data;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getRateTerms({ commit }, id) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations/${id}/get_terms`
      );
      commit('setCurrentRateTerms', res?.data);
      return res?.data;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async downloadRateAttachment(_, { id, attachment_index }) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations/${id}/download?attachment_index=${attachment_index}`,
        { responseType: 'blob' }
      );
      // commit('setCurrentRateTerms', res?.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async acceptRateTerms(_, id) {
    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations/${id}/accept_terms`
      );
      // commit('setCurrentRateTerms', res?.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async rejectRateConfirmation({ commit }, id) {
    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations/${id}/mark_as_rejected`
      );

      if (res.status !== 403 && res?.data) {
        commit('setCurrentRate', res?.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [422].includes(e?.response?.status)) {
        return e;
      } else {
        throw e;
      }
    }
  },
  async getRejectedRates(
    { commit },
    { currentPage = 1, user_id = '', searchText = '' }
  ) {
    let query = '';
    if (user_id) {
      query = `&q[creator_id_eq]=${user_id}`;
    }
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/rate_confirmations?q[s]=id+desc&q[status_eq]=rejected&page=${currentPage}&per_page=50${query}${searchText}`
      );
      commit('setRejectedRates', res);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setRates(state, res) {
    const headers = res?.headers;
    state.rates_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.rates = res?.data;
  },
  setViewedRates(state, res) {
    const headers = res?.headers;
    state.viewed_rates_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.viewed_rates = res?.data;
  },
  setDeliveredRates(state, res) {
    const headers = res?.headers;
    state.delivered_rates_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.delivered_rates = res?.data;
  },
  setDeliveredRatesIsLoaded(state, bool) {
    state.delivered_rates_is_loaded = bool;
  },
  setAcceptedRates(state, res) {
    const headers = res?.headers;
    state.accepted_rates_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.accepted_rates = res?.data;
  },
  setCurrentRate(state, data) {
    state.current_rate = data;
  },
  setCurrentRateTerms(state, data) {
    state.current_rate_terms = data;
  },
  setCancelledRates(state, res) {
    const headers = res?.headers;
    state.cancelled_rates_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.cancelled_rates = res?.data;
  },
  setRejectedRates(state, res) {
    const headers = res?.headers;
    state.rejected_rates_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.rejected_rates = res?.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
